import { render, staticRenderFns } from "./Page1Pdf3.vue?vue&type=template&id=22f87ae4&scoped=true&"
import script from "./Page1Pdf3.vue?vue&type=script&lang=js&"
export * from "./Page1Pdf3.vue?vue&type=script&lang=js&"
import style0 from "./Page1Pdf3.vue?vue&type=style&index=0&id=22f87ae4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f87ae4",
  null
  
)

export default component.exports